import { Box, Button, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EditPremiumLineLink } from '../GeneralChargesTable/components/EditPremiumLineLink';
import { useGeneralChargesContext } from 'contexts/GeneralChargesContext';
import { ContainedButton } from 'components/ContainedButton';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    padding: `${theme.spacing(2)}`,
  },
  addEntry: {
    textTransform: 'capitalize',
  },
  updateCharges: {
    textTransform: 'capitalize',
  },
}));

type Props = {
  hanldeAddEmptyCharges;
  isFormValid: boolean;
  handleOpenChangeDisclosurePolicy: () => void;
  onSubmit: () => void;
};

export const Footer: FC<Props> = ({
  hanldeAddEmptyCharges,
  isFormValid,
  handleOpenChangeDisclosurePolicy,
  onSubmit,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { chargesLetter: currentLetter, disclosureSection, hideAddEntry } = useGeneralChargesContext();
  const isMobile = !useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  return (
    <Box
      className={classes.buttonContainer}
      display="flex"
      alignItems="center"
      justifyContent={currentLetter !== "J" && !hideAddEntry ? "space-between" : "flex-end"}
    >
      {currentLetter !== "J" && !hideAddEntry && (
        <Button
          className={classes.addEntry}
          variant="outlined"
          color="secondary"
          onClick={hanldeAddEmptyCharges}
        >
          {t('charges:add-entry')}
        </Button>
      )}

      <Box style={{ display: 'flex', gap: '10px' }}>
        {!isMobile && currentLetter && ['B', 'C'].includes(currentLetter) && (
          <Box marginRight="5rem" style={{ display: 'flex', gap: '10px' }}>
            <EditPremiumLineLink />
            {disclosureSection === currentLetter && (
              <Button
                className={classes.updateCharges}
                disabled={!isFormValid}
                color="secondary"
                variant="contained"
                onClick={handleOpenChangeDisclosurePolicy}
              >
                {`${t('charges:send-title-charges-to')} ${disclosureSection === 'B' ? 'C' : 'B'}`}
              </Button>
            )}
          </Box>
        )}
        <ContainedButton
          text={t('common:save')}
          disabled={!isFormValid}
          onClick={onSubmit}
          icon="hdd"
        />
      </Box>
    </Box>
  );
};
